import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import useConfirm from 'src/hooks/useConfirm';
import useWindowSize from 'src/hooks/useWindowSize';
import { validSignedUrl } from 'src/utils/strings';
import GridCellBase from '../GridCellBase';
import Image from '../Image';
import PreviewPDF from '../PreviewPDF';
import PopUp from '../design-system/PopUp';

const pdfIcon = <i className="k-icon k-i-file-pdf k-i-pdf" />;
const imageIcon = <i className="k-icon k-i-image" />;
const FileIconCell = (props: GridCellProps) => {
  const { confirm } = useConfirm();

  const { height } = useWindowSize();

  const isPdf = useMemo(
    () => props?.dataItem?.description?.toLowerCase().endsWith('pdf'),
    [props.dataItem.description]
  );

  const Picture = useMemo(
    () =>
      isPdf ? (
        <PreviewPDF
          url={`${validSignedUrl(props?.dataItem?.signedUrl)}`}
          height={`${height * 0.8}px`}
          hoverPreview={true}
        />
      ) : (
        <Image
          src={`${validSignedUrl(props?.dataItem?.signedUrl)}`}
          styles={{
            width: '100%',
          }}
        />
      ),
    [height, isPdf, props?.dataItem?.signedUrl]
  );

  const showPreview = useCallback(() => {
    const popupHeight = '80vh';
    confirm({
      title: `${isPdf ? 'PDF' : 'Image'}  Preview`,
      content: <div className="flex justify-center items-center">{Picture}</div>,
      width: '500px',
      hasNoConfirmButton: true,
      height: popupHeight,
      cancelButtonText: 'Close',
      cancelColor: 'info',
    });
  }, [Picture, confirm, isPdf]);

  return (
    <GridCellBase {...props}>
      <PopUp
        popupAlign={{ horizontal: 'left', vertical: 'bottom' }}
        anchorAlign={{ horizontal: 'right', vertical: 'top' }}
        content={
          <div
            className={`${
              isPdf ? 'overflow-hidden' : 'overflow-auto'
            } h-[40vh] w-[270px] p-2 flex flex-col flex-grow flex-shrink flex-auto`}
          >
            {Picture}
          </div>
        }
      >
        <div title={props.dataItem.attachId} onClick={showPreview}>
          {isPdf ? pdfIcon : imageIcon}
        </div>
      </PopUp>
    </GridCellBase>
  );
};

export default FileIconCell;
